import { render } from "./resignation-modal.vue?vue&type=template&id=ae52f980"
import script from "./resignation-modal.vue?vue&type=script&lang=js"
export * from "./resignation-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__